export default "__VITE_ASSET__CKqVtN6v__"